var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"before-filtrage"},[_c('img',{attrs:{"src":_vm.searchImg,"alt":"icone de busca"}}),_c('h2',[_vm._v("Filtre para exibir dados")]),_c('p',[_vm._v("Para exibir dados no painel, utilize os filtros acima.")])])}
var staticRenderFns = []

export { render, staticRenderFns }